
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $ipRTK = parcelRequire("ipRTK");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
            baseUrl: (0, $5Ntyw.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GVWk.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== "undefined" ? window.location : {
                                pathname: "/",
                                href: "/"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});


parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-000a6a623f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error("Failed to initialize DynamicConfigClient", error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("7uNuF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5751ba2aa59ce3ed$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $5751ba2aa59ce3ed$export$2e2bcd8739ae039() {}

});

parcelRegister("etBkE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8a0bb823cdff9b6$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $a8a0bb823cdff9b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("5AtlP", function(module, exports) {
$parcel$export(module.exports, "getFirstName", function () { return $f5b50bde618a4cd3$export$cf3a9fa4cebe2986; });
function $f5b50bde618a4cd3$export$cf3a9fa4cebe2986(fullName = "") {
    return fullName.trim().split(" ")[0] || "";
}

});

parcelRegister("jgdMW", function(module, exports) {
$parcel$export(module.exports, "RowGrid", function () { return $a79cb55f58fa05ed$export$29ae18f9ecc70243; });
/* row-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $a79cb55f58fa05ed$export$29ae18f9ecc70243 = ({ children: children, numCols: numCols, colWidth: colWidth, numRows: numRows, rowHeight: rowHeight, rowGap: rowGap, columnGap: columnGap, paddingInline: paddingInline, paddingBlock: paddingBlock, marginInline: marginInline, marginBlock: marginBlock })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            gridTemplateColumns: `${(colWidth ? `${colWidth} ` : "1fr ").repeat(numCols)}`,
            gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : "1fr ").repeat(numRows)}`,
            rowGap: rowGap,
            columnGap: columnGap,
            paddingInline: paddingInline,
            paddingBlock: paddingBlock,
            marginInline: marginInline,
            marginBlock: marginBlock
        },
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};

});

parcelRegister("j2b52", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return $1445362815fc2039$export$70f10949f62d7670; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
let $1445362815fc2039$var$hydrating = true;
function $1445362815fc2039$export$1b590bd8f758497b() {
    const [hydrated, setHydrated] = (0, $1oC0p.useState)(()=>!$1445362815fc2039$var$hydrating);
    (0, $1oC0p.useEffect)(function hydrate() {
        $1445362815fc2039$var$hydrating = false;
        console.debug("hydrating:", $1445362815fc2039$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
const $1445362815fc2039$export$70f10949f62d7670 = ({ children: children })=>{
    return $1445362815fc2039$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    }) : null;
};

});

parcelRegister("3nGGx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2764a178e9687911$var$_react = $2764a178e9687911$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2764a178e9687911$var$_baseNew = $2764a178e9687911$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2764a178e9687911$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2764a178e9687911$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $2764a178e9687911$var$_react.default.createElement($2764a178e9687911$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$2764a178e9687911$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $2764a178e9687911$var$_default = module.exports.default = $2764a178e9687911$var$OfficeBuildingIcon;

});

parcelRegister("jer1f", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $e004488c10ea9ef5$export$badac9ada3a0bdf9; });

var $bCwmo = parcelRequire("bCwmo");

var $b25gw = parcelRequire("b25gw");

var $1oC0p = parcelRequire("1oC0p");

var $eVddu = parcelRequire("eVddu");

var $dLft3 = parcelRequire("dLft3");

// Export types from PopperJS / React Popper
var $e004488c10ea9ef5$var$viewportPadding = 5;
var $e004488c10ea9ef5$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $e004488c10ea9ef5$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $e004488c10ea9ef5$var$defaultChildrenFn() {
    return null;
}
var $e004488c10ea9ef5$var$defaultOffset = [
    0,
    8
];
function $e004488c10ea9ef5$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $e004488c10ea9ef5$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $e004488c10ea9ef5$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, $b25gw.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $e004488c10ea9ef5$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $dLft3.getMaxSizeModifiers)({
            viewportPadding: $e004488c10ea9ef5$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($e004488c10ea9ef5$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $bCwmo.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $bCwmo.default)(internalModifiers), (0, $bCwmo.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eVddu.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("bCwmo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $875c5860584ef4b4$export$2e2bcd8739ae039; });

var $5nzFZ = parcelRequire("5nzFZ");

var $fGMVO = parcelRequire("fGMVO");

var $6Jupj = parcelRequire("6Jupj");

var $iKQh5 = parcelRequire("iKQh5");
function $875c5860584ef4b4$export$2e2bcd8739ae039(r) {
    return (0, $5nzFZ.default)(r) || (0, $fGMVO.default)(r) || (0, $6Jupj.default)(r) || (0, $iKQh5.default)();
}

});
parcelRegister("5nzFZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3eaac64fd125a6a8$export$2e2bcd8739ae039; });

var $hRo1M = parcelRequire("hRo1M");
function $3eaac64fd125a6a8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $hRo1M.default)(r);
}

});
parcelRegister("hRo1M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $035b0019f229c993$export$2e2bcd8739ae039; });
function $035b0019f229c993$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fGMVO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6c0bc06892d3450$export$2e2bcd8739ae039; });
function $b6c0bc06892d3450$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6Jupj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e6e8851902d69fb$export$2e2bcd8739ae039; });

var $hRo1M = parcelRequire("hRo1M");
function $4e6e8851902d69fb$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $hRo1M.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $hRo1M.default)(r, a) : void 0;
    }
}

});

parcelRegister("iKQh5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da751285f552f51f$export$2e2bcd8739ae039; });
function $da751285f552f51f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("b25gw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8083f74137d7b3f6$export$2e2bcd8739ae039; });

var $2nUnB = parcelRequire("2nUnB");

var $lBHQw = parcelRequire("lBHQw");

var $6Jupj = parcelRequire("6Jupj");

var $cew88 = parcelRequire("cew88");
function $8083f74137d7b3f6$export$2e2bcd8739ae039(r, e) {
    return (0, $2nUnB.default)(r) || (0, $lBHQw.default)(r, e) || (0, $6Jupj.default)(r, e) || (0, $cew88.default)();
}

});
parcelRegister("2nUnB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bc9769a56b2f90a$export$2e2bcd8739ae039; });
function $1bc9769a56b2f90a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("lBHQw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbaf109cf8508ec4$export$2e2bcd8739ae039; });
function $fbaf109cf8508ec4$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cew88", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e7fb73ac42e1f81$export$2e2bcd8739ae039; });
function $8e7fb73ac42e1f81$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dLft3", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $a04ba9b126bdad3d$export$6d8c2b45c99d6e3f; });

var $b25gw = parcelRequire("b25gw");
function $a04ba9b126bdad3d$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $b25gw.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("3c7rQ", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $2538452475dac836$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $2538452475dac836$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $2538452475dac836$export$940e1f69e873f202; });
$parcel$export(module.exports, "B50", function () { return $2538452475dac836$export$226de0355ed012f8; });
$parcel$export(module.exports, "B100", function () { return $2538452475dac836$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $2538452475dac836$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $2538452475dac836$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "P200", function () { return $2538452475dac836$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P500", function () { return $2538452475dac836$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $2538452475dac836$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $2538452475dac836$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $2538452475dac836$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $2538452475dac836$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $2538452475dac836$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $2538452475dac836$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $2538452475dac836$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $2538452475dac836$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $2538452475dac836$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $2538452475dac836$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $2538452475dac836$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $2538452475dac836$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $2538452475dac836$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $2538452475dac836$export$920c0d5c49070351; });
$parcel$export(module.exports, "linkHover", function () { return $2538452475dac836$export$7ed258b0728b004b; });
$parcel$export(module.exports, "skeleton", function () { return $2538452475dac836$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $1dyoJ = parcelRequire("1dyoJ");
var $2538452475dac836$export$4b84fd0e2c617bd = '#FFEBE6';
var $2538452475dac836$export$b34b069eff244586 = '#FFBDAD';
var $2538452475dac836$export$be802dd0d8b57f35 = '#FF8F73';
var $2538452475dac836$export$60847d42f9da92a6 = '#FF7452';
var $2538452475dac836$export$4a7404f376229999 = '#FF5630';
var $2538452475dac836$export$2010d0fb4295b346 = '#DE350B';
var $2538452475dac836$export$2837b5a1a71d5c02 = '#BF2600';
var $2538452475dac836$export$8d9596b529bbb9cf = '#FFFAE6';
var $2538452475dac836$export$41060a744ab0b7ae = '#FFF0B3';
var $2538452475dac836$export$1cc05bbbf340e559 = '#FFE380';
var $2538452475dac836$export$5aae31392d72caaa = '#FFC400';
var $2538452475dac836$export$c6930421db9fa514 = '#FFAB00';
var $2538452475dac836$export$59619663aa6500fb = '#FF991F';
var $2538452475dac836$export$874739ea9e379ab6 = '#FF8B00';
var $2538452475dac836$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $2538452475dac836$export$69a3bf21b9686c2b = '#ABF5D1';
var $2538452475dac836$export$afbce1382ec95f73 = '#79F2C0';
var $2538452475dac836$export$747d86715d4175de = '#57D9A3';
var $2538452475dac836$export$940e1f69e873f202 = '#36B37E';
var $2538452475dac836$export$a49394138f7b8e85 = '#00875A';
var $2538452475dac836$export$6fa04827ac68a4fb = '#006644';
var $2538452475dac836$export$226de0355ed012f8 = '#DEEBFF';
var $2538452475dac836$export$8c13c2ee36917869 = '#B3D4FF';
var $2538452475dac836$export$ecfc1dff386a3e7a = '#4C9AFF';
var $2538452475dac836$export$215b7063051591f1 = '#2684FF';
var $2538452475dac836$export$e62e8919cca44969 = '#0065FF';
var $2538452475dac836$export$b3de0ae08da2ce64 = '#0052CC';
var $2538452475dac836$export$a6ee3d71bc067634 = '#0747A6';
var $2538452475dac836$export$363e4475840015bb = '#EAE6FF';
var $2538452475dac836$export$4b0a4417ed59760f = '#C0B6F2';
var $2538452475dac836$export$6011520a64d9a187 = '#998DD9';
var $2538452475dac836$export$a7175d4e9206bc80 = '#8777D9';
var $2538452475dac836$export$b48405b95304b5a1 = '#6554C0';
var $2538452475dac836$export$c71e4279dd54a18d = '#5243AA';
var $2538452475dac836$export$147899de772240ec = '#403294';
var $2538452475dac836$export$2cf711fe14c66f06 = '#E6FCFF';
var $2538452475dac836$export$7a8f4d33f6f9772c = '#B3F5FF';
var $2538452475dac836$export$776c9c497ef08533 = '#79E2F2';
var $2538452475dac836$export$69cb3ca10c1e330e = '#00C7E6';
var $2538452475dac836$export$9dc1ef0f3f48059b = '#00B8D9';
var $2538452475dac836$export$7c835c78b6fcdef8 = '#00A3BF';
var $2538452475dac836$export$6036577f95c3877e = '#008DA6';
var $2538452475dac836$export$29a4f05edc054374 = '#FFFFFF';
var $2538452475dac836$export$e655ef011c4aa1a2 = '#FAFBFC';
var $2538452475dac836$export$9fdfb749e33cdf97 = '#F4F5F7';
var $2538452475dac836$export$3e51e8f1440314ba = '#EBECF0';
var $2538452475dac836$export$1ce2d1575d444ceb = '#DFE1E6';
var $2538452475dac836$export$8754fc7e6d8b3000 = '#C1C7D0';
var $2538452475dac836$export$c2e91cbeada39b8b = '#B3BAC5';
var $2538452475dac836$export$5f71e19f3a7ad9de = '#A5ADBA';
var $2538452475dac836$export$eaa8c8a70ac22806 = '#97A0AF';
var $2538452475dac836$export$7c87d337fb91a97d = '#8993A4';
var $2538452475dac836$export$d6447c357493214f = '#7A869A';
var $2538452475dac836$export$f563ee71e9ee74cd = '#6B778C';
var $2538452475dac836$export$e2ef2124cf4024b1 = '#5E6C84';
var $2538452475dac836$export$eece5f492e429f08 = '#505F79';
var $2538452475dac836$export$c39c0fe0f26207ae = '#42526E';
var $2538452475dac836$export$7090862dc3038a9f = '#344563';
var $2538452475dac836$export$ad0bacf983b7ddaa = '#253858';
var $2538452475dac836$export$7d61b15e0da132af = '#172B4D';
var $2538452475dac836$export$fbda843f0a27fe96 = '#091E42';
var $2538452475dac836$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $2538452475dac836$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $2538452475dac836$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $2538452475dac836$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $2538452475dac836$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $2538452475dac836$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $2538452475dac836$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $2538452475dac836$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $2538452475dac836$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $2538452475dac836$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $2538452475dac836$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $2538452475dac836$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $2538452475dac836$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $2538452475dac836$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $2538452475dac836$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $2538452475dac836$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $2538452475dac836$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $2538452475dac836$export$2f6319cf7d736c2a = '#E6EDFA';
var $2538452475dac836$export$95126bc8884d6634 = '#DCE5F5';
var $2538452475dac836$export$8338d8c35d44ff1 = '#CED9EB';
var $2538452475dac836$export$5368d76ae4fbbda7 = '#B8C7E0';
var $2538452475dac836$export$9f0a771d16ec8d36 = '#ABBBD6';
var $2538452475dac836$export$abcf8c38338b4aa5 = '#9FB0CC';
var $2538452475dac836$export$97e81faa16a182c7 = '#8C9CB8';
var $2538452475dac836$export$bfe21c59123ecf33 = '#7988A3';
var $2538452475dac836$export$ee82aa2ea6a1558 = '#67758F';
var $2538452475dac836$export$682927c6ed76be02 = '#56637A';
var $2538452475dac836$export$91fd9994c5be9757 = '#455166';
var $2538452475dac836$export$d281fbfe3cff2df6 = '#3B475C';
var $2538452475dac836$export$3902c91d8b98a753 = '#313D52';
var $2538452475dac836$export$8e8133c1ba5845b5 = '#283447';
var $2538452475dac836$export$33ff357f6620b39 = '#202B3D';
var $2538452475dac836$export$633847cf062b69e0 = '#1B2638';
var $2538452475dac836$export$9776a6e503bdbf76 = '#121A29';
var $2538452475dac836$export$6c813d5160dff5db = '#0E1624';
var $2538452475dac836$export$3d4f271a500072a = '#0D1424';
var $2538452475dac836$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $2538452475dac836$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $2538452475dac836$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $2538452475dac836$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $2538452475dac836$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $2538452475dac836$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $2538452475dac836$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $2538452475dac836$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $2538452475dac836$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $2538452475dac836$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $2538452475dac836$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $2538452475dac836$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $2538452475dac836$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $2538452475dac836$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $2538452475dac836$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $2538452475dac836$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $2538452475dac836$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $2538452475dac836$export$8ce1fd94bee2f412 = (0, $1dyoJ.default)({
    light: "var(--ds-surface, ".concat($2538452475dac836$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($2538452475dac836$export$633847cf062b69e0, ")")
});
var $2538452475dac836$export$b861914ea877b580 = (0, $1dyoJ.default)({
    light: "var(--ds-background-selected, ".concat($2538452475dac836$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($2538452475dac836$export$8c13c2ee36917869, ")")
});
var $2538452475dac836$export$3f1b020df94387af = (0, $1dyoJ.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($2538452475dac836$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($2538452475dac836$export$d281fbfe3cff2df6, ")")
});
var $2538452475dac836$export$c0183dbab98ca63e = (0, $1dyoJ.default)({
    light: "var(--ds-surface-overlay, ".concat($2538452475dac836$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($2538452475dac836$export$8e8133c1ba5845b5, ")")
});
var $2538452475dac836$export$6f093cfa640b7166 = (0, $1dyoJ.default)({
    light: "var(--ds-text, ".concat($2538452475dac836$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($2538452475dac836$export$5368d76ae4fbbda7, ")")
});
var $2538452475dac836$export$42f8e9c698766e7a = (0, $1dyoJ.default)({
    light: "var(--ds-text, ".concat($2538452475dac836$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($2538452475dac836$export$5368d76ae4fbbda7, ")")
});
var $2538452475dac836$export$c2d157ca1c34b6e3 = (0, $1dyoJ.default)({
    light: "var(--ds-text-selected, ".concat($2538452475dac836$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($2538452475dac836$export$b3de0ae08da2ce64, ")")
});
var $2538452475dac836$export$1905ba28d7cf066f = (0, $1dyoJ.default)({
    light: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$97e81faa16a182c7, ")")
});
var $2538452475dac836$export$bd9002130d306d39 = (0, $1dyoJ.default)({
    light: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$bfe21c59123ecf33, ")")
});
var $2538452475dac836$export$46e4a324ac90507f = (0, $1dyoJ.default)({
    light: "var(--ds-text, ".concat($2538452475dac836$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($2538452475dac836$export$5368d76ae4fbbda7, ")")
});
var $2538452475dac836$export$79f3f2b82beb0d36 = (0, $1dyoJ.default)({
    light: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($2538452475dac836$export$97e81faa16a182c7, ")")
});
var $2538452475dac836$export$7bb0d5c671655cc4 = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$9fdfb749e33cdf97,
    dark: $2538452475dac836$export$8e8133c1ba5845b5
});
var $2538452475dac836$export$9c30223ca0a664fb = (0, $1dyoJ.default)({
    light: "var(--ds-link, ".concat($2538452475dac836$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($2538452475dac836$export$ecfc1dff386a3e7a, ")")
});
var $2538452475dac836$export$7ed258b0728b004b = (0, $1dyoJ.default)({
    light: "var(--ds-link-pressed, ".concat($2538452475dac836$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($2538452475dac836$export$215b7063051591f1, ")")
});
var $2538452475dac836$export$dfa920d8decc8a59 = (0, $1dyoJ.default)({
    light: "var(--ds-link-pressed, ".concat($2538452475dac836$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($2538452475dac836$export$ecfc1dff386a3e7a, ")")
});
var $2538452475dac836$export$6069e6ad5c78f632 = (0, $1dyoJ.default)({
    light: "var(--ds-border-focused, ".concat($2538452475dac836$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($2538452475dac836$export$215b7063051591f1, ")")
});
var $2538452475dac836$export$9ad721cf3b3debe0 = (0, $1dyoJ.default)({
    light: "var(--ds-background-brand-bold, ".concat($2538452475dac836$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($2538452475dac836$export$ecfc1dff386a3e7a, ")")
});
var $2538452475dac836$export$2aa0182783e7e9de = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$b3de0ae08da2ce64,
    dark: $2538452475dac836$export$ecfc1dff386a3e7a
});
var $2538452475dac836$export$8bf7dff220b82b4a = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$9dc1ef0f3f48059b,
    dark: $2538452475dac836$export$69cb3ca10c1e330e
});
var $2538452475dac836$export$e13cce2a2d16a9d4 = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$b48405b95304b5a1,
    dark: $2538452475dac836$export$6011520a64d9a187
});
var $2538452475dac836$export$a90204d1394caf30 = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$4a7404f376229999,
    dark: $2538452475dac836$export$4a7404f376229999
});
var $2538452475dac836$export$594c5a8758200c32 = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$c6930421db9fa514,
    dark: $2538452475dac836$export$c6930421db9fa514
});
var $2538452475dac836$export$955a2ebd2fb142ae = (0, $1dyoJ.default)({
    light: $2538452475dac836$export$940e1f69e873f202,
    dark: $2538452475dac836$export$940e1f69e873f202
});
var $2538452475dac836$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($2538452475dac836$export$8d43898f60b96a82, ")");
};

});
parcelRegister("1dyoJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e31b00b56cef74d$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $46wuO = parcelRequire("46wuO");
// Unpack custom variants, and get correct value for the current theme
function $0e31b00b56cef74d$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $46wuO.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $0e31b00b56cef74d$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $0e31b00b56cef74d$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $46wuO.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("46wuO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2fd0ee027ea13347$export$2e2bcd8739ae039; });

var $hnR5n = parcelRequire("hnR5n");
function $2fd0ee027ea13347$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $hnR5n.CHANNEL) in props.theme) return props.theme[0, $hnR5n.CHANNEL];
        else if ('mode' in props.theme && (0, $hnR5n.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $hnR5n.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("hnR5n", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $034417cbc558388b$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $034417cbc558388b$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $034417cbc558388b$export$6ba72c8346b4c57e; });

var $fgVQs = parcelRequire("fgVQs");

var $3c7rQ = parcelRequire("3c7rQ");
var $034417cbc558388b$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $034417cbc558388b$export$c93026a968943f95 = 'light';
var $034417cbc558388b$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $034417cbc558388b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $034417cbc558388b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $034417cbc558388b$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $034417cbc558388b$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $034417cbc558388b$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $034417cbc558388b$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $034417cbc558388b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $3c7rQ.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $034417cbc558388b$export$6d8204c2cb2e06b8() / 4;
    (0, $fgVQs.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $034417cbc558388b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $034417cbc558388b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $034417cbc558388b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $fgVQs.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $034417cbc558388b$export$ba1d834b86d72a09 = $034417cbc558388b$export$a1b3edb637fb4f35;
var $034417cbc558388b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $3c7rQ.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $3c7rQ.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $3c7rQ.N30A), ")")
            }
        }
    };
};

});
parcelRegister("fgVQs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b1e538753b2e462c$export$2e2bcd8739ae039; });

var $kMbep = parcelRequire("kMbep");

var $7t0tI = parcelRequire("7t0tI");
function $b1e538753b2e462c$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kMbep.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b1e538753b2e462c$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("kMbep", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f20100a75d61608f$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $f20100a75d61608f$var$printed = {};
function $f20100a75d61608f$export$2e2bcd8739ae039(message) {
    if ($f20100a75d61608f$var$printed[message]) return;
    $f20100a75d61608f$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("a9Umc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e29ae4526453fe67eff894ad5ac76ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7656760119e5c70d$var$_react = $7656760119e5c70d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7656760119e5c70d$var$_baseNew = $7656760119e5c70d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7656760119e5c70d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7656760119e5c70d$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7656760119e5c70d$var$_react.default.createElement($7656760119e5c70d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$7656760119e5c70d$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7656760119e5c70d$var$_default = module.exports.default = $7656760119e5c70d$var$CheckCircleIcon;

});

parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("7surG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e2c3c1a9226f96$var$_react = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56e2c3c1a9226f96$var$_baseNew = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56e2c3c1a9226f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e2c3c1a9226f96$var$PersonIcon = (props)=>/*#__PURE__*/ $56e2c3c1a9226f96$var$_react.default.createElement($56e2c3c1a9226f96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$56e2c3c1a9226f96$var$PersonIcon.displayName = 'PersonIcon';
var $56e2c3c1a9226f96$var$_default = module.exports.default = $56e2c3c1a9226f96$var$PersonIcon;

});

parcelRegister("gvZeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05f09ee49282e55$var$_react = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c05f09ee49282e55$var$_baseNew = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c05f09ee49282e55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05f09ee49282e55$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c05f09ee49282e55$var$_react.default.createElement($c05f09ee49282e55$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$c05f09ee49282e55$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c05f09ee49282e55$var$_default = module.exports.default = $c05f09ee49282e55$var$PeopleGroupIcon;

});

parcelRegister("LlYs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08e56f7bc5f7a423$var$_react = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $08e56f7bc5f7a423$var$_baseNew = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $08e56f7bc5f7a423$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08e56f7bc5f7a423$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $08e56f7bc5f7a423$var$_react.default.createElement($08e56f7bc5f7a423$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$08e56f7bc5f7a423$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $08e56f7bc5f7a423$var$_default = module.exports.default = $08e56f7bc5f7a423$var$InformationCircleIcon;

});

parcelRegister("4szpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f53fe53f7c5942$var$_react = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33f53fe53f7c5942$var$_baseNew = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33f53fe53f7c5942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f53fe53f7c5942$var$BacklogIcon = (props)=>/*#__PURE__*/ $33f53fe53f7c5942$var$_react.default.createElement($33f53fe53f7c5942$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f53fe53f7c5942$var$BacklogIcon.displayName = 'BacklogIcon';
var $33f53fe53f7c5942$var$_default = module.exports.default = $33f53fe53f7c5942$var$BacklogIcon;

});

parcelRegister("26k9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187bc709663ecc73$var$_react = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $187bc709663ecc73$var$_baseNew = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $187bc709663ecc73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187bc709663ecc73$var$BoardIcon = (props)=>/*#__PURE__*/ $187bc709663ecc73$var$_react.default.createElement($187bc709663ecc73$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$187bc709663ecc73$var$BoardIcon.displayName = 'BoardIcon';
var $187bc709663ecc73$var$_default = module.exports.default = $187bc709663ecc73$var$BoardIcon;

});

parcelRegister("lfTOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7964a51710834b2$var$_react = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f7964a51710834b2$var$_baseNew = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f7964a51710834b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7964a51710834b2$var$CalendarIcon = (props)=>/*#__PURE__*/ $f7964a51710834b2$var$_react.default.createElement($f7964a51710834b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$f7964a51710834b2$var$CalendarIcon.displayName = 'CalendarIcon';
var $f7964a51710834b2$var$_default = module.exports.default = $f7964a51710834b2$var$CalendarIcon;

});

parcelRegister("PQhz5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bd51b6223980e7$var$_react = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $09bd51b6223980e7$var$_baseNew = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $09bd51b6223980e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bd51b6223980e7$var$PageIcon = (props)=>/*#__PURE__*/ $09bd51b6223980e7$var$_react.default.createElement($09bd51b6223980e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$09bd51b6223980e7$var$PageIcon.displayName = 'PageIcon';
var $09bd51b6223980e7$var$_default = module.exports.default = $09bd51b6223980e7$var$PageIcon;

});

parcelRegister("fLF1J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7ab11e61c51605b$var$_react = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7ab11e61c51605b$var$_baseNew = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $b7ab11e61c51605b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7ab11e61c51605b$var$TimelineIcon = (props)=>/*#__PURE__*/ $b7ab11e61c51605b$var$_react.default.createElement($b7ab11e61c51605b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$b7ab11e61c51605b$var$TimelineIcon.displayName = 'TimelineIcon';
var $b7ab11e61c51605b$var$_default = module.exports.default = $b7ab11e61c51605b$var$TimelineIcon;

});

parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $5Ntyw = parcelRequire("5Ntyw");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.("boot", {
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher",
                    ...intercomSettings
                });
                window.Intercom?.("trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.("shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.("show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.("hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("NtjLk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $2da6ff99551ef1ce$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $8cYSw = parcelRequire("8cYSw");

var $iPPTB = parcelRequire("iPPTB");
const $2da6ff99551ef1ce$export$3c868f5963107f89 = {
    atlassian: "https://dam-cdn.atl.orangelogic.com/AssetLink/25o68v5s8lr856c06p606q47s76rs10f.svg",
    guard: "https://dam-cdn.atl.orangelogic.com/AssetLink/8j5d41rmb7q4himg4r42k3e84hvoo07i.svg"
};
const $2da6ff99551ef1ce$export$60332b2344f7fe41 = ({ align: align = "start", orientation: // we currently do not support a horizontal orientation card with an image
// the outstanding issue is that the the image has a requirement of an aspect ratio of 16:9
// and the card text is unbounded (so prioritizing the image would make the text potentially
// overflow), and prioritizing the text would make the image potentially have undesired
// white space at the end
orientation = "vertical", columns: columns, background: background = "light", eyebrow: eyebrow, logo: logo, title: title, body: body, image: image, icon: { linkedIcon: { url: iconUrl, size: iconSize = "medium", paddingIncluded: paddingIncluded = false } = {}, iconComponent: iconComponent } = {}, callToAction: callToAction, spotIllustration: spotIllustration, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = "h3", containerType: Container = "div" } = props;
    const isLinkableCard = !!callToAction;
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `card-title-${uniqueId}`;
    const callToActionId = `card-cta-${uniqueId}`;
    const bodyElement = typeof body === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
        ]),
        children: body
    }) : body;
    const card = /*#__PURE__*/ (0, $7VQPk.jsxs)(Container, {
        className: (0, $2jatx.default)([
            "_2rkovwyg _1e0c1txw _yyhy10md",
            align === "center" && "_4cvr1h6o _y3gn1h6o",
            background === "light" && "_11q7cd5j _19ityzqy",
            background === "dark" && "_11q75k8o _19it1hn0 _syazcd5j _cg41cd5j _qliycd5j _1rhqcd5j _jl6wcd5j _s974cd5j _125xcd5j _1evhcd5j _1suqcd5j",
            orientation === "vertical" && "_2lx21bp4",
            orientation === "horizontal" && "_2lx2vrvc _4t3i1osq _1bsb1osq _14q21bp4",
            isLinkableCard && "_kqswh2mm _v564mnji _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _1ni61kw8 _a7on1kw8 _clok130s _1v69130s"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200")),
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: [
            spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhxy5q _ahbqxy5q _12l2xy5q _6rthu2gc",
                    orientation === "horizontal" && "_12l2u2gc _1ob9xy5q",
                    "spotIllustrationContainer"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: spotIllustration.src,
                    alt: spotIllustration.alt ?? "",
                    style: {
                        width: spotIllustration.width ?? "auto"
                    },
                    className: (0, $2jatx.default)([
                        "_p12f1osq"
                    ])
                })
            }) : image && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reozryt _18m9zryt",
                    orientation === "vertical" && "_1s1gvwyg _5fbcvwyg",
                    orientation === "horizontal" && "_1s1gvwyg _1yxnvwyg _4t3i1osq _1bsb1osq _1e0c1txw",
                    "cardImageContainer"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    ...image,
                    src: image.src,
                    alt: image.alt,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41ejb _1e0c1txw _2lx21bp4 _zulpu2gc",
                    orientation === "vertical" && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                    orientation === "horizontal" && "_1bsb1osq _4t3i1osq _1q51xy5q"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: $2da6ff99551ef1ce$export$3c868f5963107f89[logo],
                                alt: "",
                                height: 24
                            }
                        })
                    }),
                    iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: iconUrl,
                            alt: "",
                            style: {
                                width: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                height: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                aspectRatio: "1",
                                padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[iconSize] - (0, $8cYSw.iconSizesPaddingExcluded)[iconSize]) / 2}px`,
                                objectPosition: "center"
                            }
                        })
                    }),
                    iconComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: iconComponent
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "eyebrow-md"
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "card-title"
                        ]),
                        id: titleId,
                        children: title
                    }),
                    body && bodyElement,
                    isLinkableCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            orientation === "vertical" && "_1pfh1wug",
                            "_1q51pxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: callToActionId,
                            ariaLabelledby: `${callToActionId} ${titleId}`,
                            type: "primary",
                            ...callToAction,
                            className: `full-card ${callToAction?.className ?? ""}`,
                            bgColor: background === "dark" ? "bgBlackBlue" : "bgWhite",
                            "aria-label": callToAction.text
                        })
                    })
                ]
            })
        ]
    });
    const fullWidthGridStyles = null;
    if (numColumns && orientation === "horizontal") return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _1qnyaw08 _n6am13k5"
            ]),
            style: {
                "--_18qdfwk": (0, $6ZVlx.default)(numColumns === 10 ? 2 : 1),
                "--_1xniuc0": (0, $6ZVlx.default)(numColumns === 10 ? 10 : 12)
            },
            children: card
        })
    });
    return card;
};
const $2da6ff99551ef1ce$var$cardContainer = null;
const $2da6ff99551ef1ce$var$cardContainerLight = null;
const $2da6ff99551ef1ce$var$cardContainerDark = null;
const $2da6ff99551ef1ce$var$illustrationContainer = null;
const $2da6ff99551ef1ce$var$horizontalIllustrationContainer = null;
const $2da6ff99551ef1ce$var$verticalOrientation = null;
const $2da6ff99551ef1ce$var$horizontalOrientation = null;
const $2da6ff99551ef1ce$var$centeredCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardContainer = null;
const $2da6ff99551ef1ce$var$cardImageContainer = null;
const $2da6ff99551ef1ce$var$horizontalImageContainer = null;
const $2da6ff99551ef1ce$var$verticalImageContainer = null;
const $2da6ff99551ef1ce$var$imageStyle = null;
const $2da6ff99551ef1ce$var$verticalBodyContainer = null;
const $2da6ff99551ef1ce$var$horizontalBodyContainer = null;
const $2da6ff99551ef1ce$var$cardBodyContainer = null;
const $2da6ff99551ef1ce$var$resetMargin = null;
const $2da6ff99551ef1ce$var$iconContainer = null;
const $2da6ff99551ef1ce$var$linkContainer = null;
const $2da6ff99551ef1ce$var$verticalLinkContainer = null;

});

parcelRegister("hrGO1", function(module, exports) {
$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $37d29093f218a0c9$export$9a56b303ccc53008; });
$parcel$export(module.exports, "DEFAULT_COUNTRY_ISO_CODE", function () { return $37d29093f218a0c9$export$b1f75679747bdf24; });
$parcel$export(module.exports, "DEFAULT_CURRENCY_ISO_CODE", function () { return $37d29093f218a0c9$export$427ae666c2c86a64; });
$parcel$export(module.exports, "SpecialPlanNames", function () { return $37d29093f218a0c9$export$3f5e519890ec420; });
$parcel$export(module.exports, "CloudOfferingsWithSkus", function () { return $37d29093f218a0c9$export$49640008eae271a8; });
$parcel$export(module.exports, "SpecialProductKeys", function () { return $37d29093f218a0c9$export$9bb4a98475a54313; });
$parcel$export(module.exports, "DefaultPlanLimits", function () { return $37d29093f218a0c9$export$dcfb07a55b760b78; });
$parcel$export(module.exports, "PricingStrategy", function () { return $37d29093f218a0c9$export$d5367d5d99549333; });
$parcel$export(module.exports, "parsePricingStrategy", function () { return $37d29093f218a0c9$export$b136e5eb1cbda98a; });
$parcel$export(module.exports, "TRELLO_CTA_URL", function () { return $37d29093f218a0c9$export$3d9423ec9a4e8352; });
$parcel$export(module.exports, "SIGNUP_CTA_URL", function () { return $37d29093f218a0c9$export$3c460f2e36dca740; });
$parcel$export(module.exports, "CONTACT_CTA_URL", function () { return $37d29093f218a0c9$export$cee779d81c7e245b; });
$parcel$export(module.exports, "CtaBtnText", function () { return $37d29093f218a0c9$export$7f370599117a54aa; });
$parcel$export(module.exports, "Edition", function () { return $37d29093f218a0c9$export$6f4a0f769e61929; });
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $37d29093f218a0c9$export$c5526af38120e3f; });
$parcel$export(module.exports, "COMPARE_FEATURES_CONTAINER", function () { return $37d29093f218a0c9$export$67b29c0af8205db6; });
const $37d29093f218a0c9$export$bd7123388de718a2 = {
    desktop: `@media (min-width: 1024px)`,
    tablet: `@media (max-width: 1023px)`,
    mobile: `@media (max-width: 768px)`,
    extraSmall: `@media (max-width: 360px)`
};
const $37d29093f218a0c9$export$9a56b303ccc53008 = {
    unitTierBox: "pricing_page_unit_tier_box",
    unitDescriptionTooltipTriggered: "unit-description-tooltip-triggered",
    billingCycleChanged: "billing-cycle-changed",
    planCardCTAButtonClicked: "edition-table-button-clicked",
    unitBreachModalDecision: "unit-breach-modal-decision",
    unitLimitBreachModal: "unit-limit-breach-modal",
    userTierTooltipTriggered: "user-tier-tooltip-triggered",
    showPricingExampleTriggered: "show-pricing-example-triggered",
    hidePricingExampleTriggered: "hide-pricing-example-triggered",
    pricingExampleBillingCycleChanged: "pricing-example-billing-cycle-changed",
    promoCardCTAButtonClicked: "promo-card-button-clicked"
};
const $37d29093f218a0c9$export$803d5f8ee4072798 = {
    users: "users",
    agents: "agents"
};
const $37d29093f218a0c9$export$b1f75679747bdf24 = "US";
const $37d29093f218a0c9$export$427ae666c2c86a64 = "USD";
const $37d29093f218a0c9$export$3f5e519890ec420 = {
    FREE: "Free",
    STARTER: "Starter",
    STANDARD: "Standard",
    PREMIUM: "Premium",
    ENTERPRISE: "Enterprise"
};
const $37d29093f218a0c9$export$c6264333cd6ce1a4 = {
    confluence: "pricingplan.confluence.ondemand",
    jiraSoftware: "jira-software.ondemand",
    jiraServiceDesk: "jira-servicedesk.ondemand",
    jiraServiceManagement: "jira-servicedesk.ondemand",
    bitbucket: "com.atlassian.bitbucket.manual",
    atlassianGuard: "com.atlassian.identity-manager",
    compass: "compass.ondemand",
    jiraProductDiscovery: "jira-product-discovery.ondemand",
    rovo: "rovo",
    trello: "trello",
    loom: "loom",
    teamworkCollection: "teamwork-collection",
    strategyCollection: "strategy-collection"
};
const $37d29093f218a0c9$export$49640008eae271a8 = {
    confluence: "confluence",
    jiraSoftware: "jira-software",
    jiraServiceDesk: "jira-servicedesk",
    jiraServiceManagement: "jira-servicedesk",
    atlassianGuard: "atlassian-access",
    compass: "compass",
    jiraProductDiscovery: "jira-product-discovery",
    rovo: "rovo-org-purchase-sku",
    trello: "trello",
    loom: "loom"
};
const $37d29093f218a0c9$export$2766faac8d5287ee = {
    confluence: "pricingplan.confluence-data-center",
    jiraSoftware: "jira-software.data-center",
    jiraServiceDesk: "jira-servicedesk.data-center",
    jiraServiceManagement: "jira-servicedesk.data-center",
    bitbucket: "pricingplan.stash-data-center"
};
const $37d29093f218a0c9$export$9bb4a98475a54313 = {
    JSM: "jira-servicedesk.ondemand",
    BITBUCKET: "com.atlassian.bitbucket.manual"
};
const $37d29093f218a0c9$export$dcfb07a55b760b78 = {
    UNIT_LIMIT_FREE: 10,
    UNIT_LIMIT: 150000,
    UNIT_MIN_ENTERPRISE: 801
};
const $37d29093f218a0c9$export$d5367d5d99549333 = {
    FIXED_COST: "FIXED_COST",
    MARGINAL_PER_UNIT: "MARGINAL_PER_UNIT",
    PER_UNIT: "PER_UNIT"
};
function $37d29093f218a0c9$export$a97d19165664aecc(value) {
    switch(value){
        case $37d29093f218a0c9$export$d5367d5d99549333.FIXED_COST:
        case $37d29093f218a0c9$export$d5367d5d99549333.MARGINAL_PER_UNIT:
        case $37d29093f218a0c9$export$d5367d5d99549333.PER_UNIT:
            return true;
        default:
            return false;
    }
}
function $37d29093f218a0c9$export$b136e5eb1cbda98a(value) {
    if ($37d29093f218a0c9$export$a97d19165664aecc(value)) return value;
    else throw new SyntaxError(`${value} is not a valid PricingStrategy`);
}
const $37d29093f218a0c9$export$3d9423ec9a4e8352 = "https://id.atlassian.com/signup?application=trello&continue=https%3A%2F%2Ftrello.com%2Fauth%2Fatlassian%2Fcallback%3Fdisplay%3DeyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%253D%253D&display=eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%3D%3D";
const $37d29093f218a0c9$export$3c460f2e36dca740 = "/try/cloud/signup";
const $37d29093f218a0c9$export$cee779d81c7e245b = "/enterprise/contact?formType=pricing-quotes";
const $37d29093f218a0c9$export$7f370599117a54aa = {
    GET_IT_NOW: "Get it now",
    START_FREE_TRIAL: "Start free trial",
    CONTACT_SALES: "Contact sales",
    JOIN_WAITLIST: "Join waitlist"
};
const $37d29093f218a0c9$export$6f4a0f769e61929 = {
    FREE: "free",
    STANDARD: "standard",
    PREMIUM: "premium",
    ENTERPRISE: "enterprise"
};
const $37d29093f218a0c9$export$c2f12bc66b1c3231 = 67;
const $37d29093f218a0c9$export$e528a8f1399647be = 210;
const $37d29093f218a0c9$export$27ed77542911fb0e = 1024;
const $37d29093f218a0c9$export$c5526af38120e3f = "priceBlock";
const $37d29093f218a0c9$export$67b29c0af8205db6 = "priceFeaturesTable";

});

parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            containerId: containerId,
            actionSubjectId: "pricingPlanCta",
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});


parcelRegister("dkcYJ", function(module, exports) {
$parcel$export(module.exports, "ProductCatalogClient", function () { return $44efc64b5afbeaf3$export$103ea0adeef74210; });
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return $44efc64b5afbeaf3$export$cd96e69292b0829; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return $44efc64b5afbeaf3$export$487b53c25dfbddc8; });

var $g7Jsj = parcelRequire("g7Jsj");

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");
var $44efc64b5afbeaf3$var$EDITION_SUFFIXES = /*#__PURE__*/ function(EDITION_SUFFIXES) {
    EDITION_SUFFIXES["FREE"] = ".free";
    EDITION_SUFFIXES["STANDARD"] = "";
    EDITION_SUFFIXES["PREMIUM"] = ".premium";
    EDITION_SUFFIXES["ENTERPRISE"] = ".enterprise";
    return EDITION_SUFFIXES;
}($44efc64b5afbeaf3$var$EDITION_SUFFIXES || {});
const $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES = [
    ".free",
    ".premium",
    ".enterprise"
];
class $44efc64b5afbeaf3$export$103ea0adeef74210 {
    constructor(accessToken, space, environment = "master"){
        this.accessToken = accessToken;
        this.space = space;
        this.environment = environment;
    }
    getUrl() {
        return `https://cdn.contentful.com/spaces/${this.space}/environments/${this.environment}`;
    }
    async getEntries(queryParams) {
        const url = this.getUrl();
        const response = await fetch(`${url}/entries?access_token=${this.accessToken}&${queryParams}`);
        if (response.ok) return response.json();
        throw new (0, $g7Jsj.UnsuccessfulFetchError)({
            message: "Unable to fetch prices",
            response: response
        });
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ //TODO: Update to accept CCP Offering Sku
    async getLocalizedPriceBlockPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}&include=2`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error("No pricing plans match this key");
        const parentPricingPlan = items[0];
        const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
        const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
        const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
        return {
            free: freeMonthly?.fields.configuration,
            standard: standardMonthly?.fields.configuration,
            premium: premiumMonthly?.fields.configuration
        };
    }
    async getLocalizedPriceBlockDropdown(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length || !includes) throw new Error("No pricing plans match this key");
        const fields = includes.Entry[0]?.fields.configuration;
        return fields;
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ async getHAMSPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error(`No HAMS plans match this key: ${key}`);
        const productKeys = [
            key + ".free",
            key,
            key + ".premium",
            key + ".enterprise"
        ];
        const removeEditionSuffix = (productKey)=>productKey.replace(new RegExp($44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.map((suffix)=>`\\${suffix}`).join("|") + "$"), "");
        const getPricingPlansForEditionSuffixedKey = (editionSuffixedProductKey)=>{
            const matchedEditionSuffix = $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.reduce((matchingEditionSuffix, editionSuffix)=>editionSuffixedProductKey.endsWith(editionSuffix) ? editionSuffix : matchingEditionSuffix, "");
            const parentPricingPlan = items[0];
            const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
            const freeAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanYearly?.sys.id);
            const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
            const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
            const enterpriseMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanMonthly?.sys.id);
            const standardAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanYearly?.sys.id);
            const premiumAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanYearly?.sys.id);
            const enterpriseAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanYearly?.sys.id);
            let monthly = undefined;
            let annual = undefined;
            switch(matchedEditionSuffix){
                case ".free":
                    monthly = freeMonthly?.fields.configuration;
                    annual = freeAnnual?.fields.configuration;
                    break;
                case "":
                    monthly = standardMonthly?.fields.configuration;
                    annual = standardAnnual?.fields.configuration;
                    break;
                case ".premium":
                    monthly = premiumMonthly?.fields.configuration;
                    annual = premiumAnnual?.fields.configuration;
                    break;
                case ".enterprise":
                    monthly = enterpriseMonthly?.fields.configuration;
                    annual = enterpriseAnnual?.fields.configuration;
                    break;
            }
            return {
                monthly: monthly?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier),
                annual: annual?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier)
            };
        };
        let ret = {};
        for (const productKey of productKeys){
            const editionlessKey = removeEditionSuffix(productKey);
            const entry = items.find(({ fields: { key: key } })=>key === editionlessKey);
            if (entry) ret = {
                ...ret,
                [productKey]: getPricingPlansForEditionSuffixedKey(productKey)
            };
        }
        return ret;
    }
    /**
   *
   * @param offeringSKUs the `key` property of the CCP Product
   * @returns A map of offeringSkus to their respective product plan content
   */ async getCCPPricingData(offeringSKUs) {
        const mappedOfferings = offeringSKUs.map((offeringSku, idx)=>{
            if (idx > 0) return `%2C${offeringSku}`;
            else return `=${offeringSku}`;
        }).join("");
        const ccpPricingDataQuery = `content_type=31uDFGQ9rMyZpBgP4oexja&fields.sku%5Bin%5D${mappedOfferings}`;
        const { items: items, includes: includes } = await this.getEntries(ccpPricingDataQuery);
        if (!items.length) throw new Error("No offerings match this key");
        const ret = {};
        for (const offeringSKU of offeringSKUs){
            const entry = items.find(({ fields: { sku: sku } })=>sku === offeringSKU);
            const contentfulOffering = entry?.fields;
            const pricingPlans = includes.Entry.map((includedEntry)=>{
                if (includedEntry.fields.offeringName === contentfulOffering?.name) return includedEntry.fields;
                else return undefined;
            }).filter(Boolean);
            contentfulOffering?.defaultPricingPlans?.splice(0, contentfulOffering.defaultPricingPlans.length, ...pricingPlans);
            ret[offeringSKU] = contentfulOffering;
        }
        return ret;
    }
}
function $44efc64b5afbeaf3$export$cd96e69292b0829(offeringSKUs, accessToken, space, environment) {
    const offeringSKUsCount = offeringSKUs.length;
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = (0, $1oC0p.useRef)(new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment)).current;
    const fetchData = (0, $1oC0p.useCallback)(async ()=>{
        if (offeringSKUsCount) {
            setStatus("fetching");
            const retrievedPrices = await client.getCCPPricingData(offeringSKUs);
            setPrices(retrievedPrices);
            setStatus("complete");
        } else {
            setStatus("complete");
            setPrices({});
        }
    }, [
        offeringSKUsCount
    ]);
    return {
        status: status,
        prices: prices,
        fetchData: fetchData
    };
}
function $44efc64b5afbeaf3$export$487b53c25dfbddc8(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getHAMSPrices(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        if (key) fetchData();
        else {
            setStatus("complete");
            setPrices({});
        }
    }, [
        key
    ]);
    return {
        status: status,
        prices: prices
    };
}
function $44efc64b5afbeaf3$export$cee963e0757fb89b(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getLocalizedPriceBlockPrices(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}
//TODO: Do we need this? Can we just use the types already declared and reuse them?
function $44efc64b5afbeaf3$var$mapPricingPlanToPricingTier({ pricing_strategy: pricing_strategy, unit_description: unit_description, unit_limit_lower: unit_limit_lower, unit_limit_upper: unit_limit_upper, prices: prices }) {
    return {
        pricingStrategy: (0, $hrGO1.parsePricingStrategy)(pricing_strategy),
        unitDescription: unit_description,
        unitLimitLower: unit_limit_lower,
        unitLimitUpper: unit_limit_upper,
        prices: prices.map($44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice)
    };
}
function $44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice({ currency: currency, unit_price: unit_price }) {
    return {
        currency: currency,
        unitPrice: unit_price
    };
}
function $44efc64b5afbeaf3$export$9e1397dbc82e4578(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getLocalizedPriceBlockDropdown(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}

});

parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        return (a.unitLimitLower ?? 0) - (b.unitLimitLower ?? 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = finalTier?.unitLimitUpper || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>prices.find(({ currency: currency })=>currency === currencyISOCode)?.unitPrice || 0;

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: tiers[0]?.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("cwszX", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return $a32037f0fe1c069c$export$2957fc44b3d2481; });

var $7VQPk = parcelRequire("7VQPk");

var $3c7rQ = parcelRequire("3c7rQ");
const $a32037f0fe1c069c$export$2957fc44b3d2481 = ({ size: size = "small" })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size === "small" ? "14" : "22",
        height: size === "small" ? "14" : "22",
        viewBox: "0 0 24 24",
        role: "presentation",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: "#09326C",
                    cx: "12",
                    cy: "12",
                    r: "10"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $3c7rQ.N0),
                    cx: "12",
                    cy: "18",
                    r: "1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05",
                    fill: (0, $3c7rQ.N0)
                })
            ]
        })
    });

});

parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || "horizontal";
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4bzd7 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1yg0 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === "horizontal" ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41pz4 _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === "horizontal" ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti9pc2"
                                                    ]),
                                                    style: {
                                                        height: "20px",
                                                        "--_s4yu5j": (0, $6ZVlx.default)(orientation === "vertical" ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21djo"
                    ]),
                    style: {
                        "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _1e0c1ule _y3gn1h6o _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.platformAppsHeading",
            defaultMessage: "Plus all Atlassian Platform Apps"
        }),
        includes: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.includes",
            defaultMessage: "Includes"
        }),
        home: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.home.alt",
            defaultMessage: "Home"
        }),
        goals: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.goals",
            defaultMessage: "Goals"
        }),
        teams: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.teams",
            defaultMessage: "Teams"
        }),
        studio: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.studio",
            defaultMessage: "Studio"
        }),
        search: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.search",
            defaultMessage: "Search"
        }),
        chat: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.chat",
            defaultMessage: "Chat"
        }),
        analytics: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.analytics",
            defaultMessage: "Analytics"
        }),
        admin: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.admin",
            defaultMessage: "Admin"
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    return $6e2ac6bb4e232ff3$var$MESSAGES[locale] ?? $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: "Home",
    heading: "Plus all Atlassian Platform Apps",
    includes: "Includes",
    goals: "Goals",
    teams: "Teams",
    studio: "Studio",
    search: "Search",
    chat: "Chat",
    analytics: "Analytics",
    admin: "Admin"
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: "Home",
        heading: "Plus alle Atlassian Platform-apps",
        includes: "Omvat",
        goals: "Doelstellingen",
        teams: "Teams",
        studio: "Studio",
        search: "Zoeken",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Beheerder"
    },
    es: {
        home: "Inicio",
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: "Incluye",
        goals: "Objetivos",
        teams: "Equipos",
        studio: "Studio",
        search: "Buscar",
        chat: "Chat",
        analytics: "An\xe1lisis",
        admin: "Administrativo"
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: "Accueil",
        heading: "Et toutes les apps de la plateforme Atlassian",
        includes: "Fonctionnalit\xe9s incluses",
        goals: "Objectifs",
        teams: "\xc9quipes",
        studio: "Studio",
        search: "Recherche",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Administrateur"
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: "Inclui",
        goals: "Metas",
        teams: "Equipes",
        studio: "Studio",
        search: "Pesquisar",
        chat: "Bate-papo",
        analytics: "Dados de An\xe1lise",
        admin: "Admin"
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: "Plus wszystkie aplikacje platformy Atlassian",
        includes: "Obejmuje",
        goals: "Cele",
        teams: "Zespo\u0142y",
        studio: "Studio",
        search: "Wyszukiwanie",
        chat: "Czat",
        analytics: "Analizy",
        admin: "Administrator"
    },
    de: {
        home: "Home",
        heading: "Plus alle Apps der Atlassian-Plattform",
        includes: "Beinhaltet",
        goals: "Ziele",
        teams: "Teams",
        studio: "Studio",
        search: "Suchen",
        chat: "Chat",
        analytics: "Analysen",
        admin: "Administrator"
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: "Pagina iniziale",
        heading: "E tutte le app della piattaforma di Atlassian",
        includes: "Include",
        goals: "Obiettivi",
        teams: "Team",
        studio: "Studio",
        search: "Cerca",
        chat: "Chat",
        analytics: "Analisi",
        admin: "Amministratore"
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});


parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg",
            alt: "Teamwork Collection"
        },
        products: [
            {
                name: "Jira",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg",
                    alt: "Jira"
                }
            },
            {
                name: "Confluence",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg",
                    alt: "Confluence"
                }
            },
            {
                name: "Loom",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg",
                    alt: "Loom"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("ilkqI", function(module, exports) {
$parcel$export(module.exports, "Adg4TabPanel", function () { return $640ef6c57a5f1486$export$34e8382484247e57; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $6jJHH = parcelRequire("6jJHH");

var $iyOcM = parcelRequire("iyOcM");
const $640ef6c57a5f1486$var$hidePanelStyle = null;
/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */ const $640ef6c57a5f1486$export$34e8382484247e57 = ({ forceRender: forceRender, keepInDom: keepInDom, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    children = forceRender || isTabSelected || keepInDom ? children : null;
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    const cssProp = [
        !isTabSelected && !forceRender && $640ef6c57a5f1486$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$640ef6c57a5f1486$export$34e8382484247e57.tabsRole = "Adg4TabPanel";

});

parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});

parcelRegister("9GQ1i", function(module, exports) {
$parcel$export(module.exports, "useModal", function () { return $70e0635a3b44077a$export$33ffd74ebf07f060; });

var $1oC0p = parcelRequire("1oC0p");

var $9XJwS = parcelRequire("9XJwS");
var $70e0635a3b44077a$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $1oC0p.useContext)((0, $9XJwS.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $5RBBI = parcelRequire("5RBBI");

var $kbpa7 = parcelRequire("kbpa7");

var $aHkxS = parcelRequire("aHkxS");

var $2Df35 = parcelRequire("2Df35");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");

var $ldrV1 = parcelRequire("ldrV1");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    const isShowFreeHrefButton = props.showFreeHrefButton ?? true;
    const isShowContactSalesHrefButton = props.showContactSalesHrefButton ?? false;
    const showTextWithoutLogo = props.showTextWithoutLogo ?? false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)("secondary");
    const location = (0, $1ka2O.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? "primary" : "secondary");
    };
    const getItFreeText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    const getContactSalesText = intl.formatMessage({
        id: "productNavBar.contact-sales-button",
        defaultMessage: "Contact sales"
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $80kL5.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syaz1ep1 _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px1k4ed",
                activeDropdown && "",
                activeDropdown && "_1px1qbue"
            ]),
            style: {
                "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === "" && null,
        null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== "confluence" && props.productName !== "jira" && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== "confluence" && props.productName !== "jira" && "_16qsg1bn"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazvejh _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === "" && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: "48",
                                        width: $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getItFreeText,
                                            "data-label-english": "Get it free",
                                            "data-product-key": props.dataProductKey,
                                            "data-track-event": `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getContactSalesText,
                                            "data-product-key": props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q71qli _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_u1whbc": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron400"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhk1rga _179r1k0a _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6du4vp _mqm21k0a",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44v18yz _1h6dvejh _mqm2yzqy",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1eb4 _1h6du4vp _mqm2yzqy",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});

parcelRegister("f2RFx", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $75474cece0afe122$export$8f1cb1d63697797a; });

var $7VQPk = parcelRequire("7VQPk");

var $hcVGp = parcelRequire("hcVGp");

var $lVpxp = parcelRequire("lVpxp");

var $bNHK1 = parcelRequire("bNHK1");
const $75474cece0afe122$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: "home",
        compoundNav: {
            ...(0, $lVpxp.CollectionsCompoundSubNavProps)(),
            ctaUrl: (0, $bNHK1.CTA_URL_PATH)
        }
    });
};

});
parcelRegister("lVpxp", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $41aac9f09a5b294b$export$7390cb3961621991; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $5yuBp = parcelRequire("5yuBp");
const $41aac9f09a5b294b$export$7390cb3961621991 = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $jQ0cd.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $jQ0cd.useLocalizedHref)("/collections/teamwork/features");
    const teamworkEnterpriseHref = (0, $jQ0cd.useLocalizedHref)("/collections/teamwork/enterprise");
    const teamworkPricingHref = (0, $jQ0cd.useLocalizedHref)("/collections/teamwork/pricing");
    const teamworkResourcesHref = (0, $jQ0cd.useLocalizedHref)("/collections/teamwork/resources");
    const strategyOverviewHref = (0, $jQ0cd.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $jQ0cd.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $jQ0cd.useLocalizedHref)("/collections/strategy/pricing");
    const serviceOverviewHref = (0, $jQ0cd.useLocalizedHref)("/collections/service");
    const servicePricingHref = (0, $jQ0cd.useLocalizedHref)("/collections/service/pricing");
    const softwareHref = (0, $jQ0cd.useLocalizedHref)("/collections/software");
    const collectionsHref = (0, $jQ0cd.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $5yuBp.useIsMobile)(1024);
    const hasSubnav = !isMobile;
    const props = {
        optionalClassName: "collections-nav",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.resources",
                                        defaultMessage: "Resources"
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "service",
                linkText: "Service",
                href: serviceOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "software",
                linkText: "Software",
                hasSubnav: false,
                href: softwareHref
            }
        ],
        isShowCta: false,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    return props;
};

});

parcelRegister("bNHK1", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc; });
const $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("h1dGc", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionNavbar", function () { return $b27b8dfab4fc1019$export$693b523fb4eb0711; });

var $7VQPk = parcelRequire("7VQPk");

var $hcVGp = parcelRequire("hcVGp");

var $lVpxp = parcelRequire("lVpxp");
const $b27b8dfab4fc1019$export$693b523fb4eb0711 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: "home",
        compoundNav: {
            ...(0, $lVpxp.CollectionsCompoundSubNavProps)(),
            ctaUrl: "/collections/teamwork#contact"
        }
    });
};

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $5uYpV = parcelRequire("5uYpV");

var $iOXki = parcelRequire("iOXki");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive === "overview",
            productKey: "enterprise",
            href: (0, $jQ0cd.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive === "success",
            productKey: "enterprise",
            href: (0, $jQ0cd.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive === "resources",
            productKey: "enterprise",
            href: (0, $jQ0cd.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $jQ0cd.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $jQ0cd.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.BitbucketLogo), {
        appearance: "brand"
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.CompassLogo), {
        appearance: "brand"
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).COMPASS,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $jQ0cd.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $jQ0cd.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.GuardLogo), {
        appearance: "brand"
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $jQ0cd.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $jQ0cd.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $jQ0cd.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $eIRB3 = parcelRequire("eIRB3");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eIRB3.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $jQ0cd.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $jQ0cd.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $jQ0cd.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productLogoUrl: (0, $jQ0cd.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $b31tm = parcelRequire("b31tm");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $eIRB3 = parcelRequire("eIRB3");

var $cR2Ov = parcelRequire("cR2Ov");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eIRB3.LogoV2), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/features");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/pricing");
    const itSupportHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/itsm-software");
    const itOperationsHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/it-operations");
    const enterpriseServiceManagementHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/features/enterprise-service-management");
    const customerServiceHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/customer-service-software");
    const hrHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/hr");
    const smallTeamsHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/help-desk-software-small-business-software");
    const premiumHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/premium");
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/enterprise");
    const technologyTelecomHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/technology-telecommunications");
    const financialServicesHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/financial-services");
    const retailHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/retail-ecommerce");
    const manufacturingHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/manufacturing");
    const itsmHref = (0, $jQ0cd.useLocalizedHref)("/itsm");
    const productGuideHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/product-guide");
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/resources");
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    const templatesUrl = (0, $jQ0cd.useLocalizedHref)("/software/jira/templates/service-management");
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: "viewed",
                actionSubject: "jiraServiceManagementSoftwareNavV2"
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: featuresHref
            },
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: pricingHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                dropdownType: "solutions",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.useCases.header",
                                defaultMessage: "By use case"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itSupport",
                                        defaultMessage: "IT Support"
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itOperations",
                                        defaultMessage: "IT Operations"
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.businessTeams",
                                        defaultMessage: "Business Teams"
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.customerService",
                                        defaultMessage: "Customer Service"
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.humanResources",
                                        defaultMessage: "Human Resources"
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.capability.header",
                                defaultMessage: "By capability"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.smallTeams",
                                        defaultMessage: "Small Teams"
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.premium",
                                        defaultMessage: "Premium"
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.industry.customerService",
                                defaultMessage: "By industry"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.technologyTelecom",
                                        defaultMessage: "Technology & Telecom"
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.financialServices",
                                        defaultMessage: "Financial Services"
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.retail",
                                        defaultMessage: "Retail"
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.manufacturing",
                                        defaultMessage: "Manufacturing"
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                dropdownType: "resources",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.resources.type.header",
                                defaultMessage: "By type"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.itsm",
                                        defaultMessage: "ITSM"
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: gwp7518NavIconUpdates ? intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide-gwp-7518",
                                        defaultMessage: "Guide"
                                    }) : intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide",
                                        defaultMessage: "Product Guide"
                                    }),
                                    href: productGuideHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.templates",
                                        defaultMessage: "Templates"
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.additionalResources",
                                        defaultMessage: "Additional Resources"
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        productGuideHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management"),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira-service-management",
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: false,
            mobileCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: ctaText,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: links.find((link)=>link.globalLinksKey === "solutions")?.content
                },
                {
                    menuPageKey: "resources",
                    menuPageObjects: links.find((link)=>link.globalLinksKey === "resources")?.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});

parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $6A2DX = parcelRequire("6A2DX");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $iOXki = parcelRequire("iOXki");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gWusH = parcelRequire("gWusH");

var $635dy = parcelRequire("635dy");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6A2DX.LoomAttributionLogo), {
        appearance: "brand"
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            insetBlockStart: "4.25rem",
            transform: "translateX(-25%)"
        };
    }, []);
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium");
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)("/software/loom/resources");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/loom/pricing");
    const desktopLinks = [
        {
            globalLinksKey: "features",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "solutions",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.resources",
                defaultMessage: "Solutions"
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "resources",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.useCases",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: "pricing",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    const mobileLinks = [
        ...desktopLinks.map((link)=>({
                globalLinksKey: link.globalLinksKey,
                productKey: link.productKey,
                linkText: link.linkText,
                hasSubnav: link.hasSubnav,
                href: link.href,
                dropdownType: link.globalLinksKey
            }))
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productKey: "loom",
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "LoomPageTemplate.navbar.loom-logo",
            defaultMessage: "Loom logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: desktopLinks,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-loom",
                mobileLinksProps: mobileLinks
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: "features",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: "solutions",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("gWusH", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $dfBhn = parcelRequire("dfBhn");
const $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = "loom";
    const loomLinks = {
        features: {
            id: "features",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.loomFeatures.links.features",
                defaultMessage: "Explore Features"
            }),
            items: [
                {
                    id: "meeting-notes",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.meeting-notes",
                        defaultMessage: "Meeting Notes"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/ai-meeting")
                },
                {
                    id: "screen-recorder",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screen-recorder",
                        defaultMessage: "Screen Recorder"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/screen-recorder")
                },
                {
                    id: "screenshots",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screenshots",
                        defaultMessage: "Screenshots"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/screenshot")
                },
                {
                    id: "loom-ai",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.loom-ai",
                        defaultMessage: "Loom AI"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/ai")
                },
                {
                    id: "editing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.editing",
                        defaultMessage: "Editing"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/editing")
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazmt5y _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dsmt5y _qfs11r31 _s41oglyw _1k6pnqa1 _1caymt5y _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNavSubnav",
                                        "data-product-key": productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("635dy", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $7ae29eaf01c2e45b$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $7ae29eaf01c2e45b$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: "teams",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.solution",
                defaultMessage: "Teams"
            }),
            items: [
                {
                    id: "sales",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.sales",
                        defaultMessage: "Sales"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/sales")
                },
                {
                    id: "marketing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/marketing")
                },
                {
                    id: "design",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.design",
                        defaultMessage: "Design"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/design")
                },
                {
                    id: "support",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.support",
                        defaultMessage: "Support"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/support")
                },
                {
                    id: "productmanagement",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.product-management",
                        defaultMessage: "Product Management"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/product-management")
                },
                {
                    id: "engineering",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.engineering",
                        defaultMessage: "Engineering"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/use-case/engineering")
                }
            ]
        },
        usecases: {
            id: "usecases",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.use-cases",
                defaultMessage: "Use cases"
            }),
            items: [
                {
                    id: "loom-jira",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-jira",
                        defaultMessage: "Loom + Jira"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/loom-jira")
                },
                {
                    id: "loom-confluence",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-confluence",
                        defaultMessage: "Loom + Confluence"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/loom-confluence")
                }
            ]
        },
        companysize: {
            id: "companysize",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.company-size",
                defaultMessage: "Company Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)("/software/loom/enterprise")
                }
            ]
        }
    };
}
const $7ae29eaf01c2e45b$export$e7b21fd28cd3f276 = ({ productKey: productKey = "loom" })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $7ae29eaf01c2e45b$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkcd5j _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $iOXki = parcelRequire("iOXki");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $jQ0cd.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $jQ0cd.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $jQ0cd.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $jQ0cd.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $jQ0cd.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $jQ0cd.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $jQ0cd.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const isRovoInPlanList = userSegments?.[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]?.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;
    const ctaText = intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    });
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : defaultCTAUrl;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const buttonVariant = isRovoEnabledCohort ? "secondary" : "primary";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9dCmO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6316d01b13082f$var$_react = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b6316d01b13082f$var$_baseNew = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6b6316d01b13082f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6316d01b13082f$var$CommentIcon = (props)=>/*#__PURE__*/ $6b6316d01b13082f$var$_react.default.createElement($6b6316d01b13082f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$6b6316d01b13082f$var$CommentIcon.displayName = 'CommentIcon';
var $6b6316d01b13082f$var$_default = module.exports.default = $6b6316d01b13082f$var$CommentIcon;

});

parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            cssOverrides?.labelStyle === "signup" && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !cssOverrides?.labelStyle && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler?.(selectedOption?.value || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>({
                                ...provided,
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left",
                                ...(cssOverrides || {}).container
                            }),
                        // @ts-ignore
                        singleValue: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).singleValue
                            }),
                        // @ts-ignore
                        placeholder: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).placeholder
                            }),
                        // @ts-ignore
                        valueContainer: (provided)=>({
                                ...provided,
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).valueContainer
                            }),
                        // @ts-ignore
                        menu: (provided)=>({
                                ...provided,
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)",
                                ...(cssOverrides || {}).menu
                            }),
                        // @ts-ignore
                        control: (provided, state)=>({
                                ...provided,
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                },
                                ...(cssOverrides || {}).control
                            }),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>({
                                ...provided,
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined,
                                ...(cssOverrides || {}).dropdownIndicator
                            }),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>({
                                ...provided,
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).indicatorsContainer
                            }),
                        // @ts-ignore
                        option: (provided, state)=>({
                                ...provided,
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: "#DFE1E5"
                                },
                                ...(cssOverrides || {}).option
                            }),
                        // @ts-ignore
                        input: (provided)=>({
                                ...provided,
                                color: "transparent",
                                ...(cssOverrides || {}).input
                            })
                    }
                })
            })
        ]
    });
};

});

parcelRegister("6zF1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c95d69c59142f9b$var$_react = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c95d69c59142f9b$var$_baseNew = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4c95d69c59142f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c95d69c59142f9b$var$LightbulbIcon = (props)=>/*#__PURE__*/ $4c95d69c59142f9b$var$_react.default.createElement($4c95d69c59142f9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$4c95d69c59142f9b$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $4c95d69c59142f9b$var$_default = module.exports.default = $4c95d69c59142f9b$var$LightbulbIcon;

});

parcelRegister("5tLnS", function(module, exports) {
$parcel$export(module.exports, "useDeferSiteNamingContinueUrl", function () { return $202faeefc4f73a47$export$a0ddbbade87631d7; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
// The experiment targets Jira Software only — matches the `useLoggedOutJira`
// cohort in the experiment manifest. If we ever expand to JSM / JPD, add
// their product keys here and update the experiment's cohort accordingly.
const $202faeefc4f73a47$var$JIRA_PRODUCT_KEYS = [
    (0, $fcO7r.ProductKey).JIRA_SOFTWARE
];
const $202faeefc4f73a47$export$a0ddbbade87631d7 = ()=>{
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const { locale: locale } = (0, $8e22h.default)();
    const deferSiteNamingExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).d1d6DeferSiteNaming);
    const isEnrolledInVariant = deferSiteNamingExperiment.type === "enrolled" && deferSiteNamingExperiment.value;
    return (0, $1oC0p.useCallback)(()=>{
        // Bail early for control, non-enrolled, missing product, or non-Jira products.
        // Keeping `product` in the predicate gives TS the narrowing it needs below.
        if (!isEnrolledInVariant || !product || !$202faeefc4f73a47$var$JIRA_PRODUCT_KEYS.includes(product.key)) return undefined;
        return (0, $gZgIU.getDeferSiteNamingConfirmationPageUrl)({
            productKey: product.key,
            edition: edition ?? "free",
            locale: locale
        });
    }, [
        product,
        edition,
        isEnrolledInVariant,
        locale
    ]);
};

});

parcelRegister("7H8sx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59a31c6591dcb8cb$var$_react = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $59a31c6591dcb8cb$var$_baseNew = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $59a31c6591dcb8cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59a31c6591dcb8cb$var$CameraIcon = (props)=>/*#__PURE__*/ $59a31c6591dcb8cb$var$_react.default.createElement($59a31c6591dcb8cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$59a31c6591dcb8cb$var$CameraIcon.displayName = 'CameraIcon';
var $59a31c6591dcb8cb$var$_default = module.exports.default = $59a31c6591dcb8cb$var$CameraIcon;

});

parcelRegister("gNuc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3a8a4fb00075491$var$_react = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c3a8a4fb00075491$var$_baseNew = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c3a8a4fb00075491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3a8a4fb00075491$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $c3a8a4fb00075491$var$_react.default.createElement($c3a8a4fb00075491$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c3a8a4fb00075491$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $c3a8a4fb00075491$var$_default = module.exports.default = $c3a8a4fb00075491$var$ChartTrendIcon;

});

parcelRegister("ppCkT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c634faffce0aa7$var$_react = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04c634faffce0aa7$var$_baseNew = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $04c634faffce0aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c634faffce0aa7$var$DepartmentIcon = (props)=>/*#__PURE__*/ $04c634faffce0aa7$var$_react.default.createElement($04c634faffce0aa7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$04c634faffce0aa7$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $04c634faffce0aa7$var$_default = module.exports.default = $04c634faffce0aa7$var$DepartmentIcon;

});

parcelRegister("b2tob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8096adab141a7275$var$_react = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8096adab141a7275$var$_baseNew = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8096adab141a7275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8096adab141a7275$var$EditIcon = (props)=>/*#__PURE__*/ $8096adab141a7275$var$_react.default.createElement($8096adab141a7275$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$8096adab141a7275$var$EditIcon.displayName = 'EditIcon';
var $8096adab141a7275$var$_default = module.exports.default = $8096adab141a7275$var$EditIcon;

});

parcelRegister("eMDDH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac344be6bebfa432$var$_react = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac344be6bebfa432$var$_baseNew = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac344be6bebfa432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac344be6bebfa432$var$FeedbackIcon = (props)=>/*#__PURE__*/ $ac344be6bebfa432$var$_react.default.createElement($ac344be6bebfa432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ac344be6bebfa432$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $ac344be6bebfa432$var$_default = module.exports.default = $ac344be6bebfa432$var$FeedbackIcon;

});

parcelRegister("cB1fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b9e8622fafa0ab$var$_react = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $92b9e8622fafa0ab$var$_baseNew = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92b9e8622fafa0ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b9e8622fafa0ab$var$FileIcon = (props)=>/*#__PURE__*/ $92b9e8622fafa0ab$var$_react.default.createElement($92b9e8622fafa0ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$92b9e8622fafa0ab$var$FileIcon.displayName = 'FileIcon';
var $92b9e8622fafa0ab$var$_default = module.exports.default = $92b9e8622fafa0ab$var$FileIcon;

});

parcelRegister("7Xpzl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb1e08dc9ec04f5$var$_react = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5cb1e08dc9ec04f5$var$_baseNew = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5cb1e08dc9ec04f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb1e08dc9ec04f5$var$InformationIcon = (props)=>/*#__PURE__*/ $5cb1e08dc9ec04f5$var$_react.default.createElement($5cb1e08dc9ec04f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5cb1e08dc9ec04f5$var$InformationIcon.displayName = 'InformationIcon';
var $5cb1e08dc9ec04f5$var$_default = module.exports.default = $5cb1e08dc9ec04f5$var$InformationIcon;

});

parcelRegister("6ED9p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0140140442510c7f$var$_react = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0140140442510c7f$var$_baseNew = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0140140442510c7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0140140442510c7f$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $0140140442510c7f$var$_react.default.createElement($0140140442510c7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$0140140442510c7f$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $0140140442510c7f$var$_default = module.exports.default = $0140140442510c7f$var$ListBulletedIcon;

});

parcelRegister("iMdbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dab6f123f69f6bcc$var$_react = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dab6f123f69f6bcc$var$_baseNew = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dab6f123f69f6bcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dab6f123f69f6bcc$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $dab6f123f69f6bcc$var$_react.default.createElement($dab6f123f69f6bcc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$dab6f123f69f6bcc$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $dab6f123f69f6bcc$var$_default = module.exports.default = $dab6f123f69f6bcc$var$PersonAddedIcon;

});

parcelRegister("7pQ29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56633b0430bc4d64$var$_react = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56633b0430bc4d64$var$_baseNew = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56633b0430bc4d64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56633b0430bc4d64$var$PhoneIcon = (props)=>/*#__PURE__*/ $56633b0430bc4d64$var$_react.default.createElement($56633b0430bc4d64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$56633b0430bc4d64$var$PhoneIcon.displayName = 'PhoneIcon';
var $56633b0430bc4d64$var$_default = module.exports.default = $56633b0430bc4d64$var$PhoneIcon;

});

parcelRegister("dTWad", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ed8782c3681aeb$var$_react = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1ed8782c3681aeb$var$_baseNew = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a1ed8782c3681aeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ed8782c3681aeb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $a1ed8782c3681aeb$var$_react.default.createElement($a1ed8782c3681aeb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$a1ed8782c3681aeb$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $a1ed8782c3681aeb$var$_default = module.exports.default = $a1ed8782c3681aeb$var$RoadmapIcon;

});

parcelRegister("l6HGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5dc0c5d851b1603$var$_react = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5dc0c5d851b1603$var$_baseNew = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f5dc0c5d851b1603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5dc0c5d851b1603$var$StarStarredIcon = (props)=>/*#__PURE__*/ $f5dc0c5d851b1603$var$_react.default.createElement($f5dc0c5d851b1603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$f5dc0c5d851b1603$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $f5dc0c5d851b1603$var$_default = module.exports.default = $f5dc0c5d851b1603$var$StarStarredIcon;

});

parcelRegister("gjva1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be06978ded12aba7$var$_react = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be06978ded12aba7$var$_baseNew = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be06978ded12aba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be06978ded12aba7$var$TeamsIcon = (props)=>/*#__PURE__*/ $be06978ded12aba7$var$_react.default.createElement($be06978ded12aba7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$be06978ded12aba7$var$TeamsIcon.displayName = 'TeamsIcon';
var $be06978ded12aba7$var$_default = module.exports.default = $be06978ded12aba7$var$TeamsIcon;

});

parcelRegister("kHMU7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dc2233694369e$var$_react = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f12dc2233694369e$var$_baseNew = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f12dc2233694369e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dc2233694369e$var$WarningIcon = (props)=>/*#__PURE__*/ $f12dc2233694369e$var$_react.default.createElement($f12dc2233694369e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f12dc2233694369e$var$WarningIcon.displayName = 'WarningIcon';
var $f12dc2233694369e$var$_default = module.exports.default = $f12dc2233694369e$var$WarningIcon;

});


var $67UrT = parcelRequire("67UrT");

var $3NQOU = parcelRequire("3NQOU");
(0, $3NQOU.init)((0, $67UrT.UniformEntryPage));


//# sourceMappingURL=uniform-entry-page.7584a462.js.map
